import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getCurrentOs } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { useQueryParams } from '@/utils';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

import usePopupVisible from './hooks/usePopupVisible';
import { useGetAppLinksQuery } from './queries/useGetAppLinks.query';
import ContinueInAppPopup from './ContinueInAppPopup';

const HASH_ID_QUERY_KEY = 'hash_id';

const ContinueInAppPopupStandalone = () => {
  const { visible, setVisible } = usePopupVisible();
  const { isAndroid } = getCurrentOs();
  const query = useQueryParams();
  const location = useLocation();
  const pathname = useMemo(() => location.pathname, [location]);
  const hashId = useMemo(() => query.get(HASH_ID_QUERY_KEY) || undefined, [query]);
  const { appLinks } = useGetAppLinksQuery({ hashId });
  const verificationAppLinks = useMemo(
    () => ({
      ...appLinks,
      defaultAppLink: isAndroid
        ? whiteLabelingConfig.androidAppLink || whiteLabelingConfig.androidAppStoreLink
        : whiteLabelingConfig.IOSAppLink || whiteLabelingConfig.IOSAppStoreLink,
    }),
    [appLinks, isAndroid]
  );
  if (hashId) {
    return null;
  }
  if (pathname === ROUTES.RESET_PASSWORD || pathname === ROUTES.FORGOT_PASSWORD_LINK_SENT) {
    return null;
  }
  return <ContinueInAppPopup visible={visible} setVisible={setVisible} appLinks={verificationAppLinks} />;
};

export default ContinueInAppPopupStandalone;
